// extracted by mini-css-extract-plugin
module.exports = {"container":"Price_container__BXbXm","from":"Price_from__2e8H6","number":"Price_number__3sdOp"};